import React, { useEffect } from 'react';
import classNames from 'classnames';
import Loader from 'src/components/Loader';
import styles from './assets/adminWork-create-screen.module.scss';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/AdminWorkForm';
import { IProvider } from '../../../../../../types/provider';
import { Paginated } from '../../../../../../services/api-handlers/pagination';
import { QueryParams } from '../../../../../../types/grid';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    inProgress: boolean;
    providers: Paginated<IProvider>;
}

export interface DispatchProps {
    getProviders: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const AdminWorkCreateScreen: React.FunctionComponent<Props> = (props) => {
    const { providers } = props;
    useEffect(() => {
        props.getProviders({
            page: 1,
            itemsPerPage: 1200,
        });
        // eslint-disable-next-line
    }, []);
    if (props.inProgress) {
        return <Loader />;
    }
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'ADMIN WORKS', path: routes.ADMIN_WORKS_LIST },
                    { name: `ADD NEW `, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                <Form providers={providers.list} initialValues={{}} />
            </div>
        </RoleLayout>
    );
};

export default AdminWorkCreateScreen;
